<template>
  <div>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs6>
          <v-btn flat to="/commercial" exact class="ma-0">  
            <v-icon color="grey lighten-1" class="mr-3">fas fa-angle-left</v-icon>
            <div class="headline">Ancien</div>
          </v-btn>
        </v-flex>
        <v-flex xs6 class="test-xs-right">
        </v-flex>
        <v-flex xs12 sm6 lg5>
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs8>
                  <div class="headline">{{ indicateurAncien('resasRealises', month) }} Reservations {{ $moment(month+1, 'MM').format('MMMM') }}</div>
                  <div>Objectif {{ $moment(month+1, 'MM').format('MMMM') }}: {{ indicateurAncien('objectifs', month) }}</div>
                  <div>Objectif annuel : {{ indicateurAncien('objectifs', 11) }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-center">
                  <progress-chart :data="indicateurAncien('resasRealises', month)/indicateurAncien('objectifs', month)" :width="74" :height="74"></progress-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
          <v-card class="mt-2">
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <line-chart :data="chartData2"></line-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 lg5 offset-lg1>
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs8>
                  <div class="headline">{{ indicateurAncien('actesRealises', month) }} Actes ({{ $moment(month+1, 'MM').format('MMMM') }})</div>
                  <div>Objectif {{ $moment(month+1, 'MM').format('MMMM') }} : {{ indicateurAncien('objectifs', month) }}</div>
                  <div>Objectif annuel : {{ indicateurAncien('objectifs', 11) }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-center">
                  <progress-chart :data="indicateurAncien('actesRealises', month)/indicateurAncien('objectifs', month)" :width="74" :height="74"></progress-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
          <v-card class="mt-2">
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <line-chart :data="chartData"></line-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import LineChart from '@/components/charts/LineChart.js'
import ProgressChart from '@/components/charts/ProgressChart'
import { mapGetters } from 'vuex'

export default {
  name: 'Neuf',
  components: {
    LineChart, ProgressChart
  },
  data() {
    return {
      agence : 'Toutes',
    }
  },
  computed: {
    ...mapGetters(['indicateurAncien', 'serieAncien']),
    month() {
      return this.serieAncien('actesRealises').length - 1
    },
    chartData() {
      return {
        labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        datasets: [
          {
            label: 'Réalisé',
            backgroundColor: '#E53935',
            data: this.serieAncien('actesRealises')
          },
          {
            label: 'Objectif',
            backgroundColor: '#FFCC80',
            data: this.serieAncien('objectifs')
          },
        ]
      }
    },
    chartData2() {
      return {
        labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        datasets: [
          {
            label: 'Réalisé',
            backgroundColor: '#E53935',
            data: this.serieAncien('resasRealises')
          },
          {
            label: 'Objectif',
            backgroundColor: '#FFCC80',
            data: this.serieAncien('objectifs')
          },
        ]
      }
    }
  }
}
</script>

<style scoped>

</style>
